export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7094.84b96b14.jpg";